// Import Swiper JS
import Swiper from 'swiper';
import { Navigation, Thumbs } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

export default function companySlider() {
    const thumbElement = document.querySelector('[data-swiper="thumbs"]');
    const mainElement = document.querySelector('[data-swiper="main"]');

    const companyThumbSwiper = new Swiper(thumbElement, {
        modules: [Navigation],
        spaceBetween: 12,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 4,
                spaceBetween: 16,
            },
            1024: {
                slidesPerView: 5,
            },
        },
    });

    const companySwiper = new Swiper(mainElement, {
        modules: [Thumbs],
        thumbs: {
            swiper: companyThumbSwiper,
        },
    });
}
